import { render } from "./GuiaPatentamientoMotos.vue?vue&type=template&id=450c372e&scoped=true"
import script from "./GuiaPatentamientoMotos.vue?vue&type=script&lang=js"
export * from "./GuiaPatentamientoMotos.vue?vue&type=script&lang=js"

import "./GuiaPatentamientoMotos.vue?vue&type=style&index=0&id=450c372e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450c372e"]])

export default __exports__